require('dotenv').config()

const Thmesev ="v27" 

export default Thmesev;
